module.exports = __webpack_public_path__ + "img/银翼杀手.b489fab7.gif";